import { useTonWallet } from "@tonconnect/ui-react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useUserCartStore } from "../../../features/UserCart/helpers/useUserCartStore";
import useBodyScrollLock from "../../../hooks/useBodyScrollLock";
import CartIcon from "../../Icons/CartIcon";
import LogoIcon from "../../Icons/LogoIcon";
import SearchIcon from "../../Icons/SearchIcon";
import TelegramCircleIcon from "../../Icons/TelegramCircleIcon";
import UserIcon from "../../Icons/UserIcon";
import { XIcon } from "../../Icons/XIcon";
import useMainHeader from "../helpers/useMainHeader";
import MainHeaderStore from "../stores/MainHeaderStore";
import { Cart } from "./components/Cart/Cart";
import { ConnectButton } from "./components/ConnectButton";
import { MainHeaderSearch } from "./components/MainHeaderSearch";
import { MobMenu } from "./components/MobMenu";
import { SearchMobMenu } from "./components/SearchMobMenu";
import s from "./MainHeader.module.scss";

interface Props {
  mainHeaderStore: MainHeaderStore;
  mainPage?: boolean;
  isScrolled?: boolean;
}

const links = [
  {
    title: "Channel",
    link: "https://t.me/ooiaton",
    icon: <TelegramCircleIcon />,
  },
  {
    title: "Bot",
    link: "https://t.me/ooiatonbot",
    icon: <TelegramCircleIcon />,
  },
  {
    title: "Twitter",
    link: "https://x.com/OoiaTon",
    icon: <XIcon />,
  },
  {
    title: "Channel RU",
    link: "https://t.me/ooiaton_ru",
    icon: <TelegramCircleIcon />,
  },
];

export const MainHeader: React.FC<Props> = observer(
  ({ mainHeaderStore, mainPage, isScrolled }) => {
    // const mainHeaderStore = useStore(MainHeaderStore, []);
    const cartStore = useUserCartStore();
    const { onSearchIconClick, onBurgerIconClick, onCartIconClick } =
      useMainHeader({
        mainHeaderStore,
      });
    const wallet = useTonWallet();
    const { lock, unlock } = useBodyScrollLock();

    const inputRef = useRef<HTMLInputElement>(null);

    const handleFocus = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    return (
      <div
        className={clsx(
          s.wrapper,
          mainPage && s.wrapper_main,
          isScrolled && s.bb
        )}
      >
        <div className={s.col}>
          <Link to="/" className={s.logo}>
            <LogoIcon color={mainPage ? "#fff" : "#0D0C21"} />
          </Link>
        </div>
        <div className={clsx(s.main_menu, mainPage && s.white)}>
          <div className={s.main_menu_item}>
            Community{" "}
            <div className={s.submenu_wrapper}>
              <div className={s.submenu}>
                {links.map((item, i) => (
                  <Link
                    to={item.link}
                    className={s.submenu_item}
                    key={i}
                    target="blank"
                  >
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <Link to="/lendings" className={s.main_menu_item}>
            Lendings
          </Link>
        </div>
        <div className={clsx(s.col, s.max)}>
          <div className={s.search}>
            <MainHeaderSearch
              mainHeaderStore={mainHeaderStore}
              mainPage={mainPage}
            />
          </div>

          {wallet && (
            <Cart
              headerStore={mainHeaderStore}
              isMainPage={mainPage ?? false}
            />
          )}

          <div className={s.connect}>
            <ConnectButton mainPage={mainPage} />
          </div>

          <div className={s.mobile_actions}>
            <div
              className={clsx(s.search_icon, mainPage && s.search_icon_main)}
              onClick={() => {
                onSearchIconClick();
                handleFocus();
              }}
            >
              <SearchIcon color={mainPage ? "#fff" : "#0D0C21"} />
            </div>
            {wallet && (
              <div
                className={clsx(s.cart_mob, mainPage && s.cart_main)}
                onClick={onCartIconClick}
              >
                <CartIcon color={mainPage ? "#fff" : "#0D0C21"} />
                {cartStore.cart.length > 0 && (
                  <div className={s.cart_mob_amount}>
                    <p>{cartStore.cart.length}</p>
                  </div>
                )}
              </div>
            )}
            {wallet && (
              <div
                className={clsx(s.burger, mainPage && s.burger_main)}
                onClick={onBurgerIconClick}
              >
                <UserIcon color={mainPage ? "#fff" : "#0D0C21"} />
              </div>
            )}
          </div>
        </div>
        <SearchMobMenu
          store={mainHeaderStore}
          lockBodyScroll={lock}
          unlockBodyScroll={unlock}
          inputRef={inputRef}
        />
        <MobMenu
          store={mainHeaderStore}
          lockBodyScroll={lock}
          unlockBodyScroll={unlock}
        />
      </div>
    );
  }
);
